import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';

const transformData = [
    {
        name: 'Successfully concluded',
        color: '#5b9bd5',
        value: 'attivo',
    },
    {
        name: 'Dropouts (UOA type "Project Entrepreneurs")',
        color: '#ed7d32',
        value: 'non-attivo',
    }
];

export const participantsStatusChartCalculation = (props: any) => {
    const {uoas, fields} = props;
    const statusField = fields.find((field: any) => field.key === 'status');

    const groupStatus = statusField.options.map((option: any) => ({
        key: option.key,
        y: uoas.filter((uoa: any) => uoa.custom_field_values
            .find((custom_field_value: any) => custom_field_value.field_id === statusField.id)?.stored_value === String(option.id)
        ).length
    }));

    const data = transformData.map(({name, color, value}) => ({
        name,
        color,
        y: groupStatus.find(({key}: any) => key === value)?.y || 0
    }));

    return getDefaultPieFormatting(
        '% of participants that successfully concluded the program and dropouts',
        data
    );
}